/**
 * Remove all validation. Should be called every time before revalidating form
 * @param {element} form - Form to be cleared
 * @returns {void}
 */
const clearFormErrors = form => {
    $(form).find('.form-control.is-invalid').removeClass('is-invalid');
    $(form).find('.login-form-error').empty().addClass('hidden');
};

class FormHelpers {
    init (formElement, payload) {
        // clear form validation first
        clearFormErrors(formElement);
        $('.alert', formElement).remove();

        // Chosen select
        if (Foundation.MediaQuery.atLeast('medium')) {
            if ($('select.select-chosen').length) {
                $('select.select-chosen').chosen({disable_search: true});
            }
        }

        if (typeof payload === 'object' && payload.fields) {
            Object.keys(payload.fields).forEach(function (key) {
                if (payload.fields[key]) {
                    var feedbackElement = $(formElement).find('[name="' + key + '"]')
                        .parent()
                        .children('.invalid-feedback');

                    if (feedbackElement.length > 0) {
                        if (Array.isArray(payload[key])) {
                            feedbackElement.html(payload.fields[key].join('<br/>'));
                        } else {
                            feedbackElement.html(payload.fields[key]);
                        }
                        feedbackElement.siblings('.form-control').addClass('is-invalid');
                        feedbackElement.show();
                    }
                }
            });
        }
        if (payload && payload.error) {
            $(formElement).find('.login-form-error').html(payload.error.join('<br/>')).removeClass('hidden');
        }

        var maxLength = 230;
        $('.js-contactFormMessage').keyup(function (e) {
            e.preventDefault();
            const textlen = maxLength - $(this).val().length;
            $('.egcMessageFeedbackNumber').text(textlen);
        }).keyup();
    }

    /**
     * Display error messages and highlight form fields with errors.
     * @param {string} parentSelector - the form which contains the fields
     * @param {Object} fieldErrors - the fields with errors
     */
    loadFormErrors(parentSelector, fieldErrors) { // eslint-disable-line
        // Display error messages and highlight form fields with errors.
        $.each(fieldErrors, function (attr) {
            let item = $('*[name=' + attr + ']', parentSelector).addClass('is-invalid').siblings('.invalid-feedback');
            item.html(fieldErrors[attr]);
            //item.css({visibility: 'visible'});
            item.show();
        });
    }

    /**
     * Clear the form errors.
     * @param {string} parentSelector - the parent form selector.
     */
    clearPreviousErrors (parentSelector) {
        $(parentSelector).find('.form-control.is-invalid').removeClass('is-invalid');
        $('.error-message').hide();
        $(parentSelector).find('.invalid-feedback').hide();
    }

    handleCreditCardNumber (cardFieldSelector, cardTypeSelector) {
        var cleave = new Cleave(cardFieldSelector, {
            creditCard: true,
            onCreditCardTypeChanged: type => {
                const creditCardTypes = {
                    visa: 'Visa',
                    mastercard: 'Master Card',
                    amex: 'Amex',
                    discover: 'Discover',
                    jcb: 'jcb',
                    diners: 'diners',
                    unknown: 'Unknown'
                };

                const cardType = creditCardTypes[Object.keys(creditCardTypes).indexOf(type) > -1 ? type : 'unknown'];
                $(cardTypeSelector).val(cardType);
                $('.card-number-wrapper').attr('data-type', type);
                if (type === 'visa' || type === 'mastercard' || type === 'discover') {
                    $('#securityCode').attr('maxlength', 3);
                } else {
                    $('#securityCode').attr('maxlength', 4);
                }
            }
        });

        $(cardFieldSelector).data('cleave', cleave);
    }

    serializeData (form) {
        const serializedArray = form.serializeArray();

        serializedArray.forEach(item => {
            if (item.name.indexOf('cardNumber') > -1) {
                item.value = $('#cardNumber').data('cleave').getRawValue(); // eslint-disable-line
            }
        });

        return $.param(serializedArray);
    };
}

const formHelpers = new FormHelpers();
export default formHelpers;
